import createReactComponent from '../createReactComponent';
export default createReactComponent('signal-lte', 'IconSignalLte', [
  ['path', { d: 'M21 8h-4v8h4', key: 'svg-0' }],
  ['path', { d: 'M17 12h2.5', key: 'svg-1' }],
  ['path', { d: 'M4 8v8h4', key: 'svg-2' }],
  ['path', { d: 'M10 8h4', key: 'svg-3' }],
  ['path', { d: 'M12 8v8', key: 'svg-4' }],
]);
